import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import {
  FaCheck,
  FaCoins,
  FaDiscord,
  FaMedium,
  FaSquareXTwitter,
} from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import TwitterLogin from "react-twitter-login";

import { BASE_URL, CDN_BASE_URL } from "../../config";
import { getUser } from "../../api/getUser";
import Loading from "../common/Loading";
import MediumModal from "../common/modals/MediumModal";
import TwitterModal from "../common/modals/TwitterModal";
import WheelofFourtuneModal from "../common/modals/WheelofFourtuneModal";

const DailyTasks = ({ data, getData }) => {
  return (
    <div className="rounded-[26px] bg-[#4A5A69] p-6 flex justify-center flex-col items-center relative shadow shadow-white/40 border border-white/10">
      <div className="flex flex-col w-full gap-3">
        <WheelofFourtuneModal data={data} getData={getData} />
      </div>
    </div>
  );
};

export default DailyTasks;
